/**
 * what3words helpers shared by the customer / facility forms, the booking
 * wizard and the driver manifest. Mirrors apps/api/src/transport/what3words.ts.
 */
const W3W_RE = /^\/{0,3}(\p{L}+)[.。｡・](\p{L}+)[.。｡・](\p{L}+)$/u;

/** Format-only check — "///filled.count.soap", "filled.count.soap", any case. */
export function isWhat3Words(value: string | null | undefined): boolean {
  return typeof value === 'string' && W3W_RE.test(value.trim());
}

/** "///Filled.Count.Soap" → "filled.count.soap"; null when not a what3words address. */
export function normaliseWhat3Words(value: string | null | undefined): string | null {
  if (typeof value !== 'string') return null;
  const m = W3W_RE.exec(value.trim());
  return m ? `${m[1]}.${m[2]}.${m[3]}`.toLowerCase() : null;
}

/** Display form. */
export function formatWhat3Words(words: string): string {
  return `///${normaliseWhat3Words(words) ?? words}`;
}

/** Opens the square in the what3words app / web map (with navigation hand-off). */
export function what3wordsMapUrl(words: string): string {
  return `https://what3words.com/${encodeURIComponent(normaliseWhat3Words(words) ?? words)}`;
}
